
// base_search 1.2
import {ChevronDown , ChevronRight, Filter } from "lucide-react"
import { Input, Button, MainModal, Form, Row, Col, Checkbox, Modal, Typography } from './ot'
import { useState, useEffect } from "react"

const ConditionFilterModal = ({
    items = { 類別: ["通知信", "簡報"], 狀態: ["草稿", "已發佈"] },
    value ={},
    onFormFinish = () => { },
    onCancel = () => { },
    allowCollapse = true,
    allowClearAll = true,
    ...props
}) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(value ? value : {});
    const handleClearAll = () => {
        setSelected({});
    };
    const closeModal = () => {
        setOpen(false);
    }
    const handleOk = () => {
        onFormFinish(selected)
        setOpen(false);
    };
    const handleCancel = () => {
        closeModal()
        onCancel()
        setSelected(value)
    };
    return (<>
        <Button
            variant="outline"
            size="sm"
            onClick={() => {
                setOpen(true)
            }}>
            <><Filter className="h-4 w-4 mr-1" /> 條件過濾</>
        </Button>
        <Modal
            open={open}
            title={<div className=" whitespace-nowrap overflow-hidden text-ellipsis" >  條件過濾</div>}
            width={800}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={false}
            maskClosable={false} 
            contentStyle={{
                padding: 8,
            }}
            okText={"確定"}
            cancelText={"取消"}
        >
            <Row>
                <Col span={24}>
                {allowClearAll && (
                    <div className="flex justify-end mb-4">
                        <Button danger onClick={handleClearAll}>
                            清除全部
                        </Button>
                    </div>
                )}
                </Col>
                <Col span={24}>
                    <DynamicCheckboxFilters
                        options={items}
                        selected={selected}
                        setSelected={setSelected}
                        allowCollapse={allowCollapse}
                    />
                </Col>
            </Row>

        </Modal>
    </>)
}
const DynamicCheckboxFilters = ({
    options = {},
    onChange = () => { },
    selected,
    setSelected,
    allowCollapse
}) => {

    const handleChange = (groupName, checked, value) => {
        const prev = selected[groupName] || [];
        const next = checked
            ? [...prev, value]
            : prev.filter((v) => v !== value);

        const updated = {
            ...selected,
            [groupName]: next,
        };
        setSelected(updated);
        onChange(updated); // optional callback
    };
    const [collapsed, setCollapsed] = useState({}); // 控制每個區塊的展開狀態

    const toggleCollapse = (groupName) => {
        setCollapsed((prev) => ({
            ...prev,
            [groupName]: !prev[groupName],
        }));
    };
    return (
        <Row gutter={[24, 24]}>
            {Object.entries(options).map(([groupName, optionList]) => {
                const isCollapsed = collapsed[groupName] ?? false;
                return (
                    <Col
                        key={groupName}
                        xxl={12}
                        xl={12}
                        lg={12}
                        md={24}
                        sm={24}
                        xs={24}
                    >
                        <div className="mb-2 flex items-center justify-between">
                            <Typography.Title level={4} className="m-0">
                                {groupName}
                            </Typography.Title>
                            {allowCollapse && (
                                <Button
                                    type="link"
                                    size="small"
                                    onClick={() => toggleCollapse(groupName)}
                                    icon={isCollapsed ? <ChevronRight /> : <ChevronDown />}
                                >
                                    {/* {isCollapsed ? <ChevronRight /> :<ChevronDown />} */}
                                </Button>
                            )}
                        </div>

                        {!isCollapsed && (
                            <Row gutter={[8, 8]}>
                                {optionList.map((item) => {
                                    const checked =  selected[groupName]?.includes(item) || false;
                                    return (
                                        <Col key={item} span={24}>
                                            <Checkbox
                                                checked={checked}
                                                onCheckedChange={(checked) =>
                                                    handleChange(groupName, checked, item)
                                                }
                                                className="whitespace-nowrap overflow-hidden text-ellipsis"
                                            >
                                                {item}
                                            </Checkbox>
                                        </Col>
                                    );
                                })}
                            </Row>
                        )}
                    </Col>
                );
            })}
        </Row>

    );
};
export default ConditionFilterModal